import { listContracts } from './tags';

function endpoints(builder) {
  return {
    getFairContracts: builder.query({
      query: (fairId) => `tefaf/tefafportal/fair/get-contracts/${fairId}`,
      providesTags: listContracts,
    }),
    createFairContract: builder.mutation({
      invalidatesTags: listContracts,
      query: (values) => {
        const body = new FormData();
        body.append(window.CRAFT_CSRF_PARAM, window.CRAFT_CSRF_TOKEN);
        body.append('action', 'tefaf/tefafportal/fair/create-contracts');
        body.append('fairId', (values.fairId || ''));
        values.documents.forEach((document) => {
          body.append(`documents[${document.id}][documentId]`, document.id);
          body.append(`documents[${document.id}][contractType]`, document.publicContractType);
          body.append(`documents[${document.id}][galleryName]`, document.galleryName);
        });

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
    }),
  };
}

export { endpoints };
